import * as types from "./constants";
import update from 'immutability-helper';

let initialState = window.initial_posts_data ? window.initial_posts_data : {
  objects: []
};

function postsReducer(state=initialState, action) {
  let postIndex, replyIndex, filtered, replyCount = '', liked_by, replyObj;
  switch (action.type) {
    case types.UPDATE_FEED_POST:
      postIndex = getPostIndex(state, action.postId);
      if (postIndex < 0) {
        return state;
      }
      return update(state, {
        objects: {
          [postIndex]: {$set: action.post}
        }
      });
    case types.UPDATE_FEED_REPLY_COMMENT:
      // Get index of parent post
      postIndex = getPostIndex(state, action.postId);
      if (postIndex < 0) { return state; }
      // Get index of reply
      replyIndex = getReplyIndex(state, postIndex, action.replyId);
      if (replyIndex < 0) { return state; }
      return update(state, {
        objects: {
          [postIndex]: {
            replies: {
              objects: {
                [replyIndex]: {
                  comment: {$set: action.comment},
                  mentions: {$set: action.mentions}
                }
              }
            }
          }
        }
      });
    case types.LIKE_POST:
      postIndex = getPostIndex(state, action.postId);
      if (postIndex < 0) {
        return state;
      }
      liked_by = [];
      _.each(state.objects[postIndex].liked_by, function(obj) {
        liked_by.push(obj);
      });
      liked_by.push({
        first_name: window.current_guest_name,
        id: window.user_id
      });
      return update(state, {
        objects: {
          [postIndex]: {
            liked: {$set: true},
            likes: {$set: state.objects[postIndex].likes + 1},
            liked_by: {$set: liked_by}
          }
        }
      });
    case types.UNLIKE_POST:
      postIndex = getPostIndex(state, action.postId);
      if (postIndex < 0) {
        return state;
      }
      liked_by = [];
      _.each(state.objects[postIndex].liked_by, function(obj) {
        if (obj.id !== window.user_id) {
          liked_by.push(obj);
        }
      });
      return update(state, {
        objects: {
          [postIndex]: {
            liked: {$set: false},
            likes: {$set: state.objects[postIndex].likes - 1},
            liked_by: {$set: liked_by}
          }
        }
      });
    case types.REMOVE_POST:
      filtered = state.objects.filter(function(obj) {
        return obj.id !== action.postId && obj.parent_id !== action.postId;
      });
      return update(state, {
        objects: {$set: filtered}
      });
    case types.ADD_REPLY:
      postIndex = getPostIndex(state, action.postId);
      if (postIndex < 0) {
        return state;
      }
      replyCount = state.objects[postIndex].replies.total_count || 0;
      return update(state, {
        objects: {
          [postIndex]: {
            replies: {
              objects: {$push: [action.reply]},
              total_count: {$set: replyCount + 1}
            }
          }
        }
      });
    case types.ADD_REPLIES:
      postIndex = getPostIndex(state, action.postId);
      if (postIndex < 0) {
        return state;
      }
      if (action.had_cursor) {
        return update(state, {
          objects: {
            [postIndex]: {
              replies: {
                objects : {$unshift: action.objects.reverse()},
                cursor  : {$set: action.cursor},
                more    : {$set: action.more}
              }
            }
          }
        });
      } else {
        return update(state, {
          objects: {
            [postIndex]: {
              replies: {
                objects : {$set: action.objects},
                cursor  : {$set: action.cursor},
                more    : {$set: action.more}
              }
            }
          }
        });
      }
      case types.LIKE_REPLY:
        // Get index of parent post
        postIndex = getPostIndex(state, action.postId);
        if (postIndex < 0) {
          return state;
        }
        // Get index of reply
        replyIndex = getReplyIndex(state, postIndex, action.replyId);
        if (replyIndex < 0) {
          return state;
        }
        replyObj = state.objects[postIndex].replies.objects[replyIndex];
        liked_by = [];
        _.each(replyObj.liked_by, function(obj) {
          liked_by.push(obj);
        });
        liked_by.push({
          first_name: window.current_guest_name,
          id: window.user_id
        });
        return update(state, {
          objects: {
            [postIndex]: {
              replies: {
                objects: {
                  [replyIndex]: {
                    liked: {$set: true},
                    likes: {$set: replyObj.likes + 1},
                    liked_by: {$set: liked_by}
                  }
                }
              }
            }
          }
        });
      case types.UNLIKE_REPLY:
        // Get index of parent post
        postIndex = getPostIndex(state, action.postId);
        if (postIndex < 0) {
          return state;
        }
        // Get index of reply
        replyIndex = getReplyIndex(state, postIndex, action.replyId);
        if (replyIndex < 0) {
          return state;
        }
        replyObj = state.objects[postIndex].replies.objects[replyIndex];
        liked_by = [];
        _.each(replyObj.liked_by, function(obj) {
          if (obj.id !== window.user_id) {
            liked_by.push(obj);
          }
        });
        return update(state, {
          objects: {
            [postIndex]: {
              replies: {
                objects: {
                  [replyIndex]: {
                    liked: {$set: false},
                    likes: {$set: replyObj.likes - 1},
                    liked_by: {$set: liked_by}
                  }
                }
              }
            }
          }
        });
      case types.REMOVE_REPLY:
        postIndex = getPostIndex(state, action.postId);
        if (postIndex < 0) {
          return state;
        }
        // Filter reply to delete from replies obj
        filtered = [state.objects[postIndex]][0].replies.objects.filter(
          function(reply) {
            return reply.id !== action.replyId;
          }
        );
        replyCount = state.objects[postIndex].replies.total_count || 0;
        return update(state, {
          objects: {
            [postIndex]: {
              replies: {
                objects: {$set: filtered},
                total_count: {$set: replyCount - 1}
              }
            }
          }
        });
    default:
      return state;
  }
}

function getPostIndex(state, postId) {
  return state.objects.map(function(e) {
    return e.id;
  }).indexOf(postId);
}

function getReplyIndex(state, postIndex, replyId) {
  return state.objects[postIndex].replies.objects.map(function(e) {
    return e.id;
  }).indexOf(replyId);
}

export default postsReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/reducers.es6